<template>
<w-tool-tabs class="tab-button" v-model="activeTab">
  <div slot="tool">
    <el-button size="small"  @click="onClickExportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
    <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
  </div>
  <el-tab-pane label="장비목록" name="WDeviceList">
    <el-table-wrapper ref="netinterfaceTable" border :data="tableData" :columns="tableColumns" :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;"
      :pagination="true" :remote="true" :total="tableTotal" :column-default="columnDefault" @condition-change="onChangeTable">
    </el-table-wrapper>
  </el-tab-pane>
</w-tool-tabs>
</template>

<script>
import netinterfaceInfoAPI from '@/api/config/netinterface/netinterface-info';
import FileApi from '@/api/common/file';
import msgUtil from '@/utils/message';
import { mapGetters } from 'vuex';
import { isNil } from 'lodash';
import { convertValueForInterfaceSpeed } from '@/utils/number';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';

const netinterfaceStatusOperFilters = [{ text: 'UP', value: 1 }, { text: 'DOWN', value: 2 }];
const netinterfaceStatusAdminFilters = [{ text: 'UP', value: 1 }, { text: 'DOWN', value: 0 }];
const netinterfaceDuplexFilters = [{ text: 'FULL', value: 'FULL' }, { text: 'AUTO', value: 'AUTO' }, { text: 'HALF', value: 'HALF' }];

export default {
  name: 'WConfigNetinterfaceGroup',
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      activeTab: 'WDeviceList',
      tableData: [],
      columnDefault,
      tableTotal: 0,
      showSearchTool: false,
      tableColumns: null,
      columns: [
        { prop: 'netinterfaceIfindex', remoteProp: 'ni.netinterface_ifindex', label: '인덱스', headerAlign: 'center', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'netinterfaceName', remoteProp: 'ni.netinterface_name', label: '인터페이스 명', headerAlign: 'center', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'netinterfaceAlias', remoteProp: 'ni.netinterface_alias', label: '별칭', headerAlign: 'center', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'ipaddress', label: '인터페이스 IP', remoteProp: 'ip.ipaddress', headerAlign: 'center', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'netinterfaceSpeed', label: '대역폭', remoteProp: 'ni.netinterface_speed', headerAlign: 'center', sortable: true, searchable: true, formatter: this.convertValue },
        { prop: 'netinterfaceStatusOper', remoteProp: 'ni.netinterface_status_oper', label: 'Oper 상태', headerAlign: 'center', sortable: true, formatter: this.getStateOperString, filterMultiple: false, filters: netinterfaceStatusOperFilters },
        { prop: 'netinterfaceStatusAdmin', remoteProp: 'ni.netinterface_status_admin', label: 'Admin 상태', headerAlign: 'center', sortable: true, formatter: this.getStateAdminString, filterMultiple: false, filters: netinterfaceStatusAdminFilters },
        { prop: 'vlanId', label: 'Vlan', remoteProp: 'nv.vlan_id', headerAlign: 'center', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'netinterfaceDuplex', remoteProp: 'ni.netinterface_duplex', label: 'Duplex', headerAlign: 'center', sortable: true, formatter: this.getTableValueAfterCheckEmpty, filterMultiple: false, filters: netinterfaceDuplexFilters },
        { label: '상위 네트워크 장비 정보',
          headerAlign: 'center',
          childColumns: [
            { prop: 'parentIpaddress', label: 'IP', sortable: true, headerAlign: 'center', formatter: this.getTableValueAfterCheckEmpty },
            { prop: 'parentObjtypeName', label: '장비종류', sortable: true, headerAlign: 'center', formatter: this.getTableValueAfterCheckEmpty },
            { prop: 'parentObjCompanyName', label: '제조사', sortable: true, headerAlign: 'center', formatter: this.getTableValueAfterCheckEmpty },
            { prop: 'parentObjProductId', label: '모델명', sortable: true, headerAlign: 'center', formatter: this.getTableValueAfterCheckEmpty }] },
      ],
      params: {
        managegroupIds: [],
      },
    };
  },
  computed: {
    ...mapGetters(['selectedNode', 'selectedObjDefineIdsForPhysical']),
    treeType() {
      return this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
    },
    customerId() {
      return this.$store.state.common.customerId;
    },
  },
  watch: {
    customerId: {
      handler() {
        this.setTableColumns();
      },
      immediate: true,
    },
    selectedNode: {
      handler() {
        this.params.managegroupIds = this.selectedNode.childManagegroupIds;
        if (this.$refs.netinterfaceTable === undefined) {
          this.$nextTick(() => {
            this.$refs.netinterfaceTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
            this.loadStore();
          });
        } else {
          this.$refs.netinterfaceTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
          this.loadStore();
        }
      },
      immediate: true,
    },
    selectedObjDefineIdsForPhysical() {
      this.loadStore();
    },
    active: {
      handler() {
        this.loadStore();
      },
    },
  },
  methods: {
    setTableColumns() {
      this.tableColumns = [];
      this.$nextTick(() => {
        this.tableColumns = this.columns.filter((item) => isNil(item.customerId) || (!isNil(item.customerId) && item.customerId === this.customerId));
      });
    },
    /**
     * [loadStore 그룹>장비목록 리스트 가져오기]
     * @author {Yang}
     * @return {[type]} [description]
     */
    loadStore() {
      if (this.active) {
        const tableParams = this.$refs.netinterfaceTable.getParameter();
        const params = {
          ...this.params,
          ...tableParams,
          treeType: this.treeType,
          customerId: this.customerId,
        };
        netinterfaceInfoAPI
          .getNetinterfaceConfigGroupList(params)
          .then((result) => {
            if (result.data.success === true) {
              this.tableData = result.data.data;
              this.tableTotal = result.data.total;
            }
          });
      }
    },
    convertValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValueForInterfaceSpeed(value);
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [onClickExportExcel 엑셀출력]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onClickExportExcel() {
      const tableParams = this.$refs.netinterfaceTable.getParameter();
      delete tableParams.start;
      delete tableParams.limit;
      const params = {
        ...this.params,
        ...tableParams,
        treeType: this.treeType,
        customerId: this.customerId,
      };
      netinterfaceInfoAPI.exportNetinterfaceConfigGroupList(params)
        .then((response) => {
          if (response.data.success && !isNil(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
        });
    },
    getStateOperString(row) {
      if (row.netinterfaceStatusOper === 1) {
        return 'UP';
      } else if (row.netinterfaceStatusOper === 2) {
        return 'DOWN';
      }
      return EMPTY_TEXT;
    },
    getStateAdminString(row) {
      if (row.netinterfaceStatusAdmin === 1) {
        return 'UP';
      } else if (row.netinterfaceStatusAdmin === 0) {
        return 'DOWN';
      }
      return EMPTY_TEXT;
    },
    onChangeTable() {
      this.loadStore();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/group/netinterface/index.vue